import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { dispatch } from '@store';
import { actions as actionsAuth } from '@store/auth';
import { actions as actionsGrids } from '@store/grids';
import { history } from '@history';
import { AuthService, http, ModalsService } from '@services';
import { ConstantsUtil } from '@utils';
import { getPopupErrorMessage } from '@helpers';
import { ApiResponse, Modals, Routes } from '@enums';

var ErrorInterceptor = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
    var errorObject, errorRedirect, errorInModal, redirectToErrorPage, _error$response, _error$response2, _error$response2$data, _error$response3, _error$response3$data, _error$response4, _error$response4$data, _error$response5, _error$response5$data, _error$response6, checkBlobError, killSession, config, resp, data, convertedError;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errorObject = {
              status: undefined,
              cause: undefined,
              name: '',
              stack: '',
              message: ''
            };
            errorRedirect = error.config.errorRedirect;
            errorInModal = error.config.errorInModal;

            redirectToErrorPage = function redirectToErrorPage(error) {
              var convertedError = getPopupErrorMessage(error);

              if (errorRedirect && !errorInModal) {
                history.push(Routes.Error, convertedError);
              }

              if (errorInModal) {
                void ModalsService.open(Modals.Error, _objectSpread({
                  maxWidth: 456
                }, convertedError));
              }
            };

            if (!error.response) {
              _context.next = 41;
              break;
            }

            checkBlobError = function checkBlobError(error) {
              if (error instanceof Blob && error.type === 'text/plain') {
                return error.text();
              }

              return undefined;
            };

            killSession = function killSession() {
              AuthService.removeTokenLocalStorage();
              dispatch(actionsAuth.logoutUserSuccess());
              dispatch(actionsGrids.closeAllGrids());
              history.push(Routes.Login);
            }; // Request made and server responded


            errorObject.status = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
            errorObject.name = (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.Error) || (error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.error);
            _context.t1 = (error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.detail) || (error === null || error === void 0 ? void 0 : (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$data = _error$response5.data) === null || _error$response5$data === void 0 ? void 0 : _error$response5$data.Detail);

            if (_context.t1) {
              _context.next = 14;
              break;
            }

            _context.next = 13;
            return checkBlobError(error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.data);

          case 13:
            _context.t1 = _context.sent;

          case 14:
            _context.t0 = _context.t1;

            if (_context.t0) {
              _context.next = 17;
              break;
            }

            _context.t0 = '';

          case 17:
            errorObject.message = _context.t0;
            _context.t2 = error.response.status;
            _context.next = _context.t2 === ApiResponse.InvalidToken ? 21 : _context.t2 === ApiResponse.Unauthorized ? 34 : _context.t2 === ApiResponse.NotFound ? 36 : 38;
            break;

          case 21:
            config = error === null || error === void 0 ? void 0 : error.config;

            if (config !== null && config !== void 0 && config.doNotRefreshIntercept) {
              _context.next = 32;
              break;
            }

            config.doNotRefreshIntercept = true;
            _context.next = 26;
            return AuthService.memoizedRefreshAccessToken();

          case 26:
            resp = _context.sent;
            data = resp === null || resp === void 0 ? void 0 : resp.data;

            if (data.accessToken && data.refreshToken) {
              AuthService.setTokenLocalStorage(data.accessToken, data.refreshToken);
            } else {
              killSession();
            }

            return _context.abrupt("return", http(config));

          case 32:
            killSession();

          case 33:
            return _context.abrupt("break", 39);

          case 34:
            killSession();
            return _context.abrupt("break", 39);

          case 36:
            history.push(Routes.NotFound);
            return _context.abrupt("break", 39);

          case 38:
            redirectToErrorPage(errorObject);

          case 39:
            _context.next = 42;
            break;

          case 41:
            if (error.request) {
              // The request was made but no response was received
              errorObject.message = ConstantsUtil.errors.NETWORK_ERROR;
              redirectToErrorPage(errorObject);
            } else {
              // Something happened in setting up the request that triggered an Error
              errorObject.message = ConstantsUtil.errors.NETWORK_SETTING_ERROR;
              redirectToErrorPage(errorObject);
            }

          case 42:
            convertedError = getPopupErrorMessage(errorObject);
            return _context.abrupt("return", Promise.reject(convertedError));

          case 44:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function ErrorInterceptor(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { ErrorInterceptor };